import QueryContext from '../QueryContext';
import api from '../index';

const verticalTagFetchers = {
  verticalTags: (context?: QueryContext) => api.get('/vertical_tags', {}),
};

export default verticalTagFetchers;
